import { Stack, Typography } from '@mui/material';
import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from './FieldProps';

export function GenericInputField<TValues extends FieldValues>({
  name,
  Input,
  label,
}: FieldProps<TValues> & {
  Input: React.ComponentType<{
    value: any;
    onChange: (value: any) => void;
    required: boolean;
    label: string;
  }>;
  label?: string;
}) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    name,
    control,
  });
  // console.log('name', name);
  // console.log('error', error);
  // console.log('value', value);
  return (
    <Stack>
      <Input
        value={value as number}
        onChange={onChange}
        label={label || ''}
        required
      />
      {error && (
        <Typography color='#ff0000' variant='caption'>
          {error.message}
        </Typography>
      )}
    </Stack>
  );
}
